import 'globals';

const tabletWidth = 992;

function checkNavbarState(element) {
    const windowWidth = window.innerWidth;

    if (element.classList.contains('show') && (windowWidth <= tabletWidth)) {
        document.body.classList.add('overflow-hidden');
    } else {
        document.body.classList.remove('overflow-hidden');
    }
}

(function (window, PageLoadedQueue) {
    const navbarMenu = document.querySelector('#navbarNavDropdown');

    window.PageLoadedQueue.addFunction(function() {
        window.addEventListener('resize', () => {
            checkNavbarState(navbarMenu);
        });

        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if(mutation.attributeName == "class") {
                    checkNavbarState(mutation.target);
                }
            });
        });
        observer.observe(navbarMenu, {attributes: true});
    });
})(window, window.PageLoadedQueue);
